<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
      <template >
        <v-toolbar flat>  
          <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-filter</v-icon>{{ this.$store.state.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-flex lg3>
              <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
            </v-flex>


            
          <v-dialog v-model="dialogGenerate" max-width="500px">
            <!-- <template v-slot:activator="{ on, attrs }">
              <v-btn outlined v-show=insertact rounded small color="primary" class="mb-2" v-bind="attrs" v-on="on">
                Generat Query Monitoring
                <v-icon class="ml-2">mdi-cogs</v-icon>
              </v-btn>
            </template>-->
            <v-card>
              <v-card-title>
                <v-card-title><span class="text-h6">Generate Query Prameter Prometheus</span></v-card-title>
              </v-card-title>
              <v-card-text height="auto">
                
                <v-form class="ml-2" ref="formsetting" lazy-validation>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                          <v-text-field 
                            prepend-inner-icon="mdi-menu" 
                            outlined dense 
                            v-model="baseurlgenerate" 
                            label="Base Url">
                          </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="closeGenerate">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" style="width: 120px;" rounded dark dense :loading="btnloadGenerate" @click="savesetting">
                  Generate
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          


            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }" >
                <v-btn outlined v-show=insertact  rounded small color="primary" class="mb-2" v-bind="attrs" v-on="on">
                  Add New Data
                  <v-icon class="ml-2">mdi-plus</v-icon>
                </v-btn>
              </template> 
              <v-card>
                <v-card-title>
                  <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
                </v-card-title>
                <v-card-text style="height: 400px;" class="overflow-card">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field 
                          prepend-inner-icon="mdi-cogs" 
                          outlined dense 
                          v-model="inputItem.paramid" 
                          label="Param ID">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field 
                          prepend-inner-icon="mdi-menu" 
                          outlined dense 
                          v-model="inputItem.description" 
                          label="Deskripsi">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field 
                          prepend-inner-icon="mdi-grid" 
                          outlined dense 
                          v-model="inputItem.tabs" 
                          label="Tab">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field 
                          prepend-inner-icon="mdi-pencil" 
                          outlined dense 
                          v-model="inputItem.param" 
                          label="Param">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="py-3">
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="save">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" width="330px"> 
              <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
                <v-avatar class="color-avatar3 my-4" size="62">
                  <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
                </v-avatar>
                <div class="text-center text-h6 align-center justify-center font-weight-medium">
                  Confirm Deletion
                </div>
                <v-card-text class="align-center justify-center mt-2">
                  Are you sure you want to permanently delete this item?
                </v-card-text>
                <v-divider class="mt-4" style=""></v-divider>
                <v-card-actions class="align-center justify-center">
                  <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                    OK
                  </v-btn>
                  <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
        </v-toolbar>
      </template>
      <v-data-table 
      :headers="headers"
      :items="variableparameter"
      :search="search"
      sort-by="paramid"
      class="ml-6 mr-6 mt-4 rounded-lg"
      :loading="tableLoading"
      loading-text="Loading data..."
      >
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon v-show=updateact  small class="mr-2" @click="editItem(item.PARAM_ID)">
          mdi-pencil
        </v-icon>
        <v-icon v-show=deleteact  @click="deleteItem(item.PARAM_ID)" small>
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <Notification  ref="alert"></Notification>
  </div>
</template>
<script>
import axios from "axios";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      btnload:false,
      btnloadGenerate:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",
      baseurlgenerate:"",
      matricexplorer:[],
      deleteact: false,
      insertact: false,
      updateact: false,
      viewact: false,
      dialog: false,
      dialogGenerate: false,
      dialogDelete: false,
      search:'',
      headers: [
        { text: 'Param ID', value: 'PARAM_ID' },
        { text: 'Description', value: 'DESCRIPTION' },
        { text: 'Tabs', value: 'TABS' },
        { text: 'Param', value: 'PARAM' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
       
      variableparameter: [],
      id_param:'',
      param_id_edit:'',
      editedIndex: -1,
      inputItem: {
      },
      defaultItem: {
      },
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add Variable Parameter' : 'Update Variable Parameter'
      },
    },
    watch: {
      
      dialogGenerate (val) {
        val || this.closeGenerate()
      },
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

    },
    created () {
      this.initialize()
    },
    methods: {
      initialize () {
        this.tableLoading = true;
        axios.get("parameter",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            // this.variableparameter = response.data;
            var res = decryptionData(response.data.token);
            this.variableparameter = res.data;
            this.baseurlgenerate =res.baseurl_prometheus;
            // auth action  {{ this.$store.state.title }}
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(this.$store.state.insert == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }  
            setTimeout(() =>{
              this.loading = false
            },1000)
            this.tableLoading = false;
          })
          .catch((e) => {
              switch (e.response.status) {
                  case 404:
                        this.$refs.alert.error_login(404);
                      break;
                  case 403:
                        this.$refs.alert.error_login(403);
                      break;
                  default:
                      console.log('some other error');  // end up here all the time
                      break;
              }
          this.errors=e.response.data.msg;
        });
        
      },
      deleteItem (item) {
        
        this.id_param = item
        this.editedIndex = this.variableparameter.indexOf(item)
        this.inputItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.variableparameter.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "/parameter/delete",
          data: {
            param_id: this.id_param
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          this.initialize();
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.closeDelete()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.closeDelete()
              } 
        })
        .catch(function (error) {
          console.log(error);
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed';
          this.btnload = false
          this.closeDelete()
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.inputItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      editItem (item) {
        this.editedIndex = 1
        this.inputItem = Object.assign({}, item)
        this.dialog = true
        axios({
          method: "put",
          url: "/parameterId",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            // const dat = response.data;
            const dat  = decryptionData(response.data.token);

            this.id_param = dat.PARAM_ID;
            this.param_id_edit = dat.PARAM_ID;
            this.inputItem = {
              paramid:dat.PARAM_ID,
              description:dat.DESCRIPTION,
              tabs:dat.TABS,
              param:dat.PARAM,
            }
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          console.log(error);
        })
      },
      save () {
        
        this.btnload = true
        if (this.editedIndex > -1) {
          axios.put("/parameter/update", 
            {
              param_id:this.inputItem.paramid,
              param_id_edit:this.param_id_edit,
              description:this.inputItem.description,
              tabs:this.inputItem.tabs,
              param:this.inputItem.param,
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
            this.initialize();
              this.$router.push('/variableparameter');
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.close()
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                      case 404:
                            this.$refs.alert.error_login(404);
                          break;
                      case 403:
                            this.$refs.alert.error_login(403);
                          break;
                      case 400:
                            this.alertFailed = true;
                            this.alert_err_attention =  e.response.msg;
                            this.btnload = false
                          break;
                      default:
                          console.log('some other error');  // end up here all the time
                          break;
                }
            this.errors=e.response.data.msg;
          });
          Object.assign(this.variableparameter[this.editedIndex], this.inputItem)

        } else {
          axios.post("/parameter/insert", 
            {
              param_id:this.inputItem.paramid,
              description:this.inputItem.description,
              tabs:this.inputItem.tabs,
              param:this.inputItem.param,
              
            },
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
            this.initialize();
              this.$router.push('/variableparameter');
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.btnload = false
                this.close()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.close()
              } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                  case 400:
                        this.alertFailed = true;
                        this.alert_err_attention =  e.response.data.msg;
                        this.btnload = false
                      break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
            this.errors=e.response.data.msg;
          });
          
        }
      },
      
      async savesetting () {
        try {
          this.btnloadGenerate = true

          const response = await axios.get(this.baseurlgenerate);
          const metricData = response.data.data;
          this.matricexplorer = metricData.map((item) => ({
            MATRIC: item,
            SEQ_ID_MATRIC: item // Atau ID lainnya yang relevan
          }));
          var no = 0;
          for (let data of this.matricexplorer) {
            no++
            const hasil = await this.generateInsertOne(data.MATRIC.toUpperCase(), 'Prometheus', data.MATRIC);
            console.log(hasil); // You can log or process the result as needed.
          }

          if(this.matricexplorer.length == no){
            this.dialogGenerate = false
            this.btnloadGenerate = false
            this.initialize();
            this.$router.push('/variableparameter');
            this.alertSuccess = true;
            this.alert_err_attention =  'Generate Success';
          }

        } catch (error) {
          console.error("Error fetching metric data:", error);
        }
      },
      async generateInsertOne (PARM_ID, TAB, PARM) {
        try {
          const response = await axios.post("/parameter/generate", {
            param_id:  PARM_ID,
            description: '',
            tabs: TAB,
            param: PARM
          }, {
            headers: {
              'auth-token': localStorage.getItem('token_app')
            }
          });

          const { status, msg } = response.data;

          if (status === 200) {
            return { success: true, message: msg }; // Return a success response object
          } else {
            return { success: false, message: msg }; // Return failure response object
          }

        } catch (e) {
          if (e.response) {
            switch (e.response.status) {
              case 404:
                return { success: false, message: 'Not Found (404)' };
              case 403:
                return { success: false, message: 'Forbidden (403)' };
              case 400:
                return { success: false, message: e.response.data.msg };
              default:
                console.error('Some other error occurred', e);
                return { success: false, message: 'An unexpected error occurred' };
            }
          } else {
            console.error('Network or other error:', e);
            return { success: false, message: 'Network error or other issue' };
          }
        }
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.inputItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      
      closeGenerate () {
        this.dialogGenerate = false
        this.btnloadGenerate = false
      },
    },
  }
</script> 

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>
